<template>
    <div>
        <Title :tablist="tabs" :tabactive="tab_active" @titleTabActive="titleTabActive"/>

<!--        <div class="fxboex head">-->
<!--            <div class="back backtit" @click="goBack">返回</div>-->
<!--            <div class="title">{{tabs[0]}}</div>-->
<!--        </div>-->


        <div class="order">
            <div class="page-loading" v-if="init===true">
                <van-skeleton title :row="8" />
            </div>
            <template v-else>
                <template v-if="list.length>0">

                    <div :class="['tuijiebox tuijiebox_or', tab_active === 2 || (tab_active !== 2&&total[1]>0) || (tab_active===0&&total[1]===0)?'tuijiebox_or'+tab_active:'']">
                        <van-checkbox-group v-model="chk_select_list">
                        <div v-for="(c, i) in list" :key="i" :class="['item',c.match.dystatus !== 2?'itemdis':'']">

                            <van-swipe-cell>
                                <van-cell>

                                    <div class="hd">
<!--                                        <input type="checkbox" v-if="tab_active === 2" :value="c.cid" v-model="chk_select_list" @change="changeCheck(i)" />-->
<!--                                        <input type="checkbox" v-else-if="c.match.dystatus===2" :value="c.cid" v-model="chk_select_list" @change="changeCheck(i)" />-->
                                        <div class="vanchk" v-if="tab_active === 2 || c.match.dystatus === 2 || (tab_active === 0&&total[1]===0)">
                                            <van-checkbox :name="c.cid" shape="square" checked-color="#f4882a" icon-size="18px" @click="changeCheck(i)"/>
                                        </div>

                                        <div class="ss" :style="{color:c.match.dystatus===2?c.match.style:'#999'}">{{ c.match.match_type }}</div>
                                        <div class="time">{{ c.match.start }}</div>
                                        <div class="ex">
                                            <template v-if="c.match.isfree">单场精选</template>
                                            <router-link :to="'/expert/'+c.match.expert_ename" v-else>
                                                <img :src="c.match.expert_portrait" class="port"/>
                                                <span class="t">{{ c.match.expert_name }}</span>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="dz">
                                        <router-link :to="'/match/'+c.match.mid">
                                            {{ c.match.shangpan }}<span class="bf">VS</span>{{ c.match.xiapan }}
                                        </router-link>
                                        <div class="pk" v-if="c.match.dystatus === 2">
                                            <em v-if="c.match.dxq">大小球</em><em v-else>让球</em>{{ c.match.pk }}
                                        </div>
                                    </div>
                                    <div class="ds" v-if="c.match.dystatus === 2">
                                        <template v-if="c.match.dystatus === 2">
                                            <span class="sj" v-if="c.match.isfree"><i>现售</i>{{ c.match.amt }}<em>FXB</em></span>
                                            <template v-else>
                                                <span class="od"><i>原售</i>{{ c.match.expert_dianshu }}<em>FXB</em></span>
                                                <span class="sj"><i>现售</i>{{ c.match.amt }}<em>FXB</em></span>
                                            </template>
                                        </template>
                                        <span class="sj" v-else><i>售价</i>{{ c.match.expert_dianshu }}<em>FXB</em></span>
                                    </div>

                                    <div class="jfen">
                                        <label v-if="c.match.dystatus === 2">
                                            <input type="checkbox" class="jifen" @change="changeJfCheck(i)" v-model="c.select_jf" :value="c.match.mid"><span>积分抵扣</span>
                                            <b>{{ c.match.deduction }}%</b>（{{ c.match.deduction_amt }}<em>FXB</em>）
                                        </label>
                                        <div class="yd" v-if="c.match.dystatus === 1">已订</div>
                                        <div class="gk" v-else-if="c.match.dystatus !== 2"></div>
                                        <div class="sheng" v-else-if="c.match.dystatus === 2 && c.match.sytime_text">订阅剩余：<div>{{c.match.sytime_text}}</div></div>
                                    </div>

                                </van-cell>
                                <template #right>
                                    <van-button square type="danger" text="删除" @click="deleteDg(i, c.match.dystatus)" />
                                </template>
                            </van-swipe-cell>

                        </div>
                        </van-checkbox-group>
                    </div>

                    <div class="fxboex caraction" v-if="tab_active === 2 || total[1] === 0">
                        <div class="con">
<!--                            <label :class="overischkAll?'on':''"><input type="checkbox" v-model="overischkAll" @click="checkedOverAll"> 全选</label>-->
                        <van-checkbox v-model="overischkAll" shape="square" checked-color="#f4882a">全选</van-checkbox>
                        <span class="cartdel" @click="deletePl">删除</span>
                        <div class="text">
                            <span id="orderamthj">已选择<b>{{chk_select_list.length}}</b>场，</span>
                            <span>共<b>{{ total[2] }}</b>场</span>
                        </div>
                        </div>
                    </div>
                    <template v-else>
                    <div class="fxboex carbtm" v-if="total[1]>0">
                        <div class="lf">
<!--                            <label :class="ischkAll?'on':''"><input type="checkbox" v-model="ischkAll" @click="checkedAll"> 全选</label>-->
                            <van-checkbox v-model="ischkAll" shape="square" checked-color="#f4882a" icon-size="18px">全选</van-checkbox>
                            <span class="cartdel" @click="deletePl">删除</span>
<!--                            <span class="orderclear" @click="deleteOver">清除失效</span>-->
                            <div class="ysel">已选择 <b>{{chk_select_list.length}}</b> 场</div>
                        </div>
                        <div class="paycnf">
                            <template v-if="chk_select_list.length>0">
                                <div class="amt amt_sj" @click="closeCartDet">
                                    <i>支付金额</i><em>{{amt_pay}}</em><span>FXB</span>
                                </div>
                                <div class="amt amt_yh" @click="closeCartDet">
                                    共优惠{{amt_total-amt_pay}}FXB <span>查看明细</span>
                                </div>
                            </template>
                            <div class="amt" v-else>
                                <i>支付金额</i><em>{{amt_pay}}</em><span>FXB</span>
                            </div>
                            <button :class="['btnsure', isAction?'btndis':'']" type="button" @click="submit(0)">确认订阅</button>
                        </div>
                    </div>
                    </template>

                    <div class="fxboex detpop" @click="closeCartDet" v-if="showPopup===true"></div>
                    <div class="fxboex carbmdet" v-if="showPopup===true">
                        <div class="ltit">订阅明细<i @click="closeCartDet"></i></div>
                        <div class="item yue">
                            <div class="title">当前余额</div>
                            <div class="con"><span>{{ user.amt }}</span><em class="unit">FXB</em></div>
                        </div>
                        <div class="item yue yue2">
                            <div class="title">当前积分</div>
                            <div class="con"><span>{{ user.integral_def }}</span><em class="unit">JF</em></div>
                        </div>
                        <div class="line"></div>
                        <div class="item total">
                            <div class="title">合计金额</div>
                            <div class="con"><em>{{amt_total}}</em><i class="unit">FXB</i></div>
                        </div>
                        <div class="item deduction">
                            <div class="title">优惠活动</div>
                            <div class="con cousel">
<!--                                <select name="coupon" @change="changeCoupon" v-model="coupon_select_id">-->
<!--                                    <template v-if="coupon.length > 0">-->
<!--                                        <option value="0">不使用优惠券</option>-->
<!--                                        <option v-for="(c,i) in coupon" :key="i" :value="c.id" :disabled="c.disabled">{{ c.name }}</option>-->
<!--                                    </template>-->
<!--                                    <option value="0" v-else>暂无优惠券</option>-->
<!--                                </select>-->
                                <div @click="showCouponActionSheet" class="cpact">{{coupon_select_text}}</div>
                                <span class="jian" v-if="coupon_select_amt > 0">-{{coupon_select_amt}}</span>
                                <van-action-sheet v-model="showCouponSheet" title="选择优惠券" cancel-text="取消" :actions="coupon" @select="selectCoupon"/>
                            </div>
                        </div>
                        <div class="item integral">
                            <div class="title">积分抵扣</div>
                            <div class="con">
                                <em v-if="amt_deduction>0" class="jian">-{{amt_deduction}}</em><em v-else>0</em>
<!--                                <router-link to="/coupon">领券</router-link>-->
                            </div>
                        </div>
                        <div class="line"></div>
                        <div class="read">订阅前请仔细阅读《<span @click="toTreaty">用户协议</span>》及《<span @click="toMianze">免责声明</span>》</div>
                        <div class="line"></div>
                    </div>

                </template>
                <van-empty v-else class="ordernone" description="没内容~">
                    <router-link to="/ball">去订阅贴士 &gt;&gt;</router-link>
                </van-empty>
            </template>
        </div>

<!--        <van-popup position="bottom" v-model="cart_confirm_show" :duration=".1">-->
        <van-dialog v-model="cart_confirm_show" v-if="cart_confirm!=null" title="确认订阅" show-cancel-button @confirm="submit(1)">
            <div class="dyconfpop">
                <div class="ifo">
                    <div class="ifocn"><span class="nw">支付金额 <em>{{cart_confirm.amt_pay}}<i>FXB</i></em></span></div>
                    <template v-if="cart_confirm.integral_deduction > 0 || cart_confirm.coupon_deduction > 0">（<span class="yh" v-if="cart_confirm.coupon_deduction > 0">优惠券 -{{cart_confirm.coupon_deduction}}</span>
                        <template v-if="cart_confirm.integral_deduction > 0">
                            <template v-if="cart_confirm.coupon_deduction > 0">,</template>
                            <span class="yh">积分 -{{cart_confirm.integral_deduction}}</span>
                        </template>）</template>
                </div>
                <div class="yue">当前余额 <span>{{ cart_confirm.yue }}</span><em>FXB</em>， 积分 <i>{{cart_confirm.ing}}</i></div>
            </div>
        </van-dialog>
<!--        </van-popup>-->

    </div>
</template>

<script>
    import Title from './../components/public/title'
    export default {
        name: "cart",
        components: {
            Title
        },
        data() {
            return {
                timer: null,
                formPath: '',
                list: [],
                tab_active: 0,
                action: ['all', 'invalid', 'over'],
                total: [0, 0, 0],
                tabs_def: ['购物车', '可订阅', '已失效'],
                // total: [0, 0],
                // tabs_def: ['购物车', '已失效'],
                tabs: [],
                carsize_cur: 0,
                user: null,
                page: 1,
                init: true,
                coupon: [],
                coupon_select_id: 0,
                coupon_select_amt: 0,
                isSelectCoupon: false,
                ischkAll: false,
                amt_deduction: 0,
                amt_total: 0,
                amt_pay: 0,

                chk_select_list: [],
                overischkAll: false,

                cart_confirm: null,
                cart_confirm_show: false,

                showPopup: false,
                showCouponSheet: false,
                coupon_select_text_def: '选择优惠券',
                coupon_select_text: '选择优惠券',

                isAction: false
            }
        },
        watch: {
            /**
             * 监控
             * */
            '$route': {
                handler: function (v) {
                    if(v.path === '/cart') {
                        // this.list = []
                        // this.init = true
                        // this.getdata()
                        this.ischkAll = false
                        this.chk_select_list = []
                        this.overischkAll = false
                        this.isSelectCoupon = false
                    }
                }
            },
            ischkAll(v){
                let that = this
                // that.user.integral = this.user.integral_def
                that.isSelectCoupon = false
                // that.ischkAll = !that.ischkAll
                that.chk_select_list = []
                if(v){
                    that.list.forEach(function (c) {
                        if(c.match.dystatus === 2) {
                            c.select = true
                            c.select_jf = true
                            // console.log(c.cid)
                            that.chk_select_list.push(c.cid)
                        }
                    })
                }
                else{
                    that.coupon_select_id = 0
                    that.coupon_select_amt = 0
                    that.coupon_select_text = that.coupon_select_text_def
                    that.list.forEach(function (c) {
                        c.select = false
                        c.select_jf = false
                    })
                }
                this.calculation()
            },
            list(v){
                let that = this
                let tmplist = []
                v.forEach(function(c){
                    tmplist.push(c.cid)
                })
                that.chk_select_list.forEach(function (k, i) {
                    if(tmplist.indexOf(k) === -1){
                        that.chk_select_list.splice(i, 1)
                    }
                })
            },
            overischkAll(v){
                let that = this
                // that.overischkAll = !that.overischkAll
                that.chk_select_list = []
                if(v){
                    that.list.forEach(function (c) {
                        that.chk_select_list.push(c.cid)
                    })
                }
            },
        },
        activated() {
            let that = this
            that.list = []
            that.init = true
            that.tabs = []
            that.tab_active = 0
            that.getdata()
        },
        methods: {
            titleTabActive(v){
                this.tab_active = v
                this.init = true
                // this.tabs_select = i
                this.ischkAll = false
                this.list = []
                this.chk_select_list = []
                this.overischkAll = false
                this.getdata()
                this.calculation()
            },
            closeCartDet(){
              this.showPopup = !this.showPopup
            },
            calculation(){
                let that = this
                if(that.user) {
                    that.user.integral = that.user.integral_def
                    let select_amt_total = 0 //选中总金额
                    that.list.forEach(function (c) {
                        // console.log(c.select)
                        if (c.select) {
                            let amt = c.match.amt_def //默认销售金额
                            select_amt_total += amt
                        } else {
                            c.match.amt = c.match.amt_def
                        }
                    })
                    // console.log(select_amt_total)
                    that.amt_total = select_amt_total  //合计金额
                    // console.log(that.isSelectCoupon)
                    //选中相应优惠券
                    if (select_amt_total > 0) {
                        if (!that.isSelectCoupon) {
                            that.coupon_select_id = 0
                            let selcoupon = false
                            that.coupon.forEach(function (c) {
                                c.disabled = true
                                // console.log(select_amt_total, c.amt_condition)
                                if (select_amt_total >= c.amt_condition) {
                                    c.disabled = false
                                    if (selcoupon) return
                                    that.coupon_select_amt = c.amt
                                    that.coupon_select_id = c.id
                                    that.coupon_select_text = c.name
                                    selcoupon = true
                                }
                                else{
                                    that.coupon_select_amt = 0
                                    that.coupon_select_id = 0
                                    that.coupon_select_text = that.coupon_select_text_def
                                }
                            })
                        }
                    } else {
                        that.coupon_select_id = 0
                        that.coupon_select_amt = 0
                        that.coupon_select_text = that.coupon_select_text_def
                    }
                    //选中优惠券后重新设置销售金额
                    that.list.forEach(function (c) {
                        c.match.amt = c.match.amt_def
                        c.match.amt_new = c.match.amt  //优惠券后的销售金额，下面积分优惠使用
                        c.match.amt_coupon = 0  //优惠了多少
                        if (c.select && that.coupon_select_amt > 0) {
                            var sjamt = c.match.amt - Math.round(Math.round(c.match.amt / select_amt_total * that.coupon_select_amt * 1000) / 1000) //使用优惠券后通过比例得到金额
                            c.match.amt = sjamt
                            c.match.amt_new = c.match.amt
                            c.match.amt_coupon = c.match.amt_def - sjamt
                        }
                    })

                    let integral_total = 0
                    //设置积分优惠
                    if (that.user.integral > 0) {
                        that.list.forEach(function (c) {
                            if (that.user.integral > 0 && c.select) {
                                if (c.select_jf) {
                                    let amt = c.match.amt_new
                                    let deduction_amt = c.match.deduction_amt //最多可抵扣金额
                                    if (that.user.integral < deduction_amt) {
                                        deduction_amt = that.user.integral
                                    }
                                    integral_total += deduction_amt
                                    amt -= deduction_amt
                                    that.user.integral -= deduction_amt
                                    c.match.amt = amt
                                    c.match.amt_integral = deduction_amt
                                } else {
                                    c.match.amt = c.match.amt_new
                                    c.match.amt_integral = 0
                                }
                            } else {
                                c.match.amt_integral = 0
                            }
                        })
                    }
                    that.amt_deduction = integral_total
                    // console.log(select_amt_total, that.coupon_select_amt, integral_total)
                    that.amt_pay = select_amt_total - that.coupon_select_amt - integral_total
                }
            },

            showCouponActionSheet(){
                this.showCouponSheet = !this.showCouponSheet
            },
            selectCoupon(item){
                let that = this
                // console.log(item.name)
                that.isSelectCoupon = true
                that.coupon_select_amt = item.amt
                that.coupon_select_text = item.name
                that.coupon_select_id = item.id
                that.showCouponActionSheet()
                that.calculation()
            },

            changeCoupon(e){
                let that = this

                that.isSelectCoupon = true
                let selectIndex = e.target.options.selectedIndex
                // console.log(selectIndex)
                if(selectIndex === 0){
                    that.coupon_select_amt = 0
                    that.coupon_select_id = 0
                }
                else{
                    selectIndex -= 1
                    that.coupon_select_amt = that.coupon[selectIndex].amt
                }
                that.calculation()
            },
            changeCheck(i){
                // this.user.integral = this.user.integral_def
                this.list[i].select = !this.list[i].select
                this.list[i].select_jf = this.list[i].select
                // console.log(this.chk_select_list)
                // console.log(i)
                this.isSelectCoupon = false
                this.calculation()
            },
            changeJfCheck(){
                // console.log(i)
                // this.user.integral = this.user.integral_def  //重新计算积分
                this.isSelectCoupon = false
                this.calculation()
            },
            getdata(){
                let that = this
                that.ball = that.$route.meta.ball
                that.$get(that.$api.cart_list, {action: that.action[that.tab_active]})
                    .then(function (res) {
                        // console.log(res)
                        if(res.code === 1) {
                            // console.log(res.data)
                            that.list = res.data.list
                            that.list.forEach(function (c) {
                                c.match.amt_def = c.match.amt
                            })
                            that.total = res.data.total
                            that.setTotalText()
                            that.user = res.data.user
                            that.user.integral_def = res.data.user.integral
                            that.carsize_cur = res.data.carsize_cur
                            that.coupon = res.data.coupon

                            that.init = false
                        }
                    })
            },
            setTotalText(){
                let that = this
                let tabstmp = []
                that.tabs_def.forEach(function (c, i) {
                    tabstmp.push(c + ' '+ that.total[i]+'')
                })
                that.tabs = tabstmp
                // that.tabs[0] = that.tabs_def[0]+' '+ that.total[0]
                // that.tabs[1] = that.tabs_def[1]+' '+ that.total[2]
            },
            submit(zftype){
                let that = this
                if(that.isAction) return
                if(that.chk_select_list.length===0){
                  that.$toast('请选择一项')
                  return
                }
                let data={}
                //let ids=[], sjamt=[], yhamt=[], jfamt=[]
                let match = []
                that.list.forEach(function (c) {
                  if(c.select){
                      match.push({
                          'id': c.match.mid,
                          'amt': c.match.amt,
                          'amt_coupon': c.match.amt_coupon,
                          'amt_integral': c.match.amt_integral
                      })
                  }
                })
                data = {
                    'amt_total': that.amt_pay,
                    'integral_total': that.amt_deduction,
                    'coupon': that.coupon_select_id,
                    'user_amt': that.user.amt,
                    'user_integral': that.user.integral_def,
                    'zftype': zftype,
                    'match': match
                }
                if(zftype === 1) {
                    that.isAction = true
                }
                // console.log(data)
                data = escape(JSON.stringify(data))
                // console.log(data)
                that.$post(that.$api.cartsubmit, {content: data}).then(function (res) {
                    // console.log(res)
                    if(res.code === 1){
                        that.$toast.success(res.msg)
                        if(res.data.coupon)
                            that.coupon = res.data.coupon
                        that.coupon_select_amt = 0
                        that.coupon_select_id = 0
                        that.updateOverAction(res)
                        that.$router.push({path: '/account/subscribe'})
                    }
                    else if(res.code === 2){
                        //that.$dialog.alert(res.msg)
                        //账户有变动
                        that.$toast.fail(res.msg)
                        if(res.data.amt)
                            that.user.amt = res.data.amt
                        if(res.data.integral)
                            that.user.integral_def = res.data.integral
                        if(res.data.coupon)
                            that.coupon = res.data.coupon
                        that.isSelectCoupon = false
                        that.calculation()
                    }
                    else if(res.code === 3){
                        //余额不足
                        // that.$dialog.alert({title: '系统提示', message: res.msg})
                        that.$dialog.confirm({
                            confirmButtonText: '立即充值',
                            message:res.msg,
                            title: '系统提示',

                        }).then(()=>{
                            that.$router.replace({path: '/account/recharge'})
                            that.$store.commit('CLOSE_DING')
                        }).catch(()=>{
                            // that.isAction = false
                        })
                    }
                    else if(res.code === 4){
                        that.cart_confirm = {
                            amt_pay: that.amt_pay,
                            integral_deduction: that.amt_deduction,
                            coupon_deduction: that.coupon_select_amt,
                            yue: res.data.amt,
                            ing: res.data.integral
                        }
                        that.cart_confirm_show = true
                    }
                    else{
                        that.$toast.fail(res.msg)
                    }
                })
            },
            /**
             * 单个删除
             * */
            deleteDg(i, st){
                let that = this
                let id = that.list[i].cid
                if(st===2) {
                    that.$dialog.confirm({title: '确认', message: '确定删除？'}).then(function () {
                        that.deletePost(that, id, i)
                    }).catch(() => {
                    })
                }
                else{
                    that.deletePost(that, id, i)
                }
                // console.log(that.chk_select_list.length)
            },
            /**
             * 单个删除请求
             * */
            deletePost(that, id, i){
                that.chk_select_list.reverse().forEach(function (c, idx) {
                    console.log(c === id)
                    if(c === id){
                        that.chk_select_list.splice(1, idx)
                    }
                })
                // console.log(i)
                that.$post(that.$api.cartDelDg, {cid: id}).then(function (res) {
                    // console.log(res)
                    if(res.code === 1){
                        that.$toast.success(res.msg)

                        that.list.splice(i, 1)
                        that.total = [res.data.size.all, res.data.size.invalid, res.data.size.over]
                        that.updateStorageUserInfo(that.total[1])

                        that.calculation()
                    }else
                        that.$toast.fail(res.msg)
                })
            },
            /**
             * 批量删除
             * */
            deletePl(){
                let that = this
                if(that.chk_select_list.length === 0){
                    that.$toast('请选择一项')
                    return
                }
                that.deletePlPost()
            },

            /**
             * 清除失效
             */
            deleteOver(){
                let that = this
                let list = [], splice_list = []
                that.list.forEach(function (c, i) {
                    if(c.match.dystatus !== 2) {
                        list.push(c.cid)
                        splice_list.push(i)
                    }
                })
                if(list.length === 0){
                    that.$toast('暂无失效内容')
                    return
                }
                this.deletePlPost({
                    data: list.join(','),
                    message:'确定清除失效内容？',
                    url: that.$api.cartClearOver,
                    callback: function () {
                        splice_list.reverse().forEach(function (c) {
                            that.list.splice(c, 1)
                        })
                    }
                })
            },
            deletePlPost(paramer=null){
                let that = this
                if(paramer==null) {
                    paramer = {
                        data: that.chk_select_list.join(','),
                        message: '确定删除选中项？',
                        url: that.$api.cartDelPl
                    }
                }
                that.$dialog.confirm({title: '确认', message: paramer.message}).then(function () {
                    that.$post(paramer.url, {cid: paramer.data}).then(function (res) {
                        // console.log(res)
                        if(res.code === 1){
                            that.$toast.success(res.msg)

                            if(paramer.callback){
                                paramer.callback()
                                that.total = [res.data.size.all, res.data.size.invalid, res.data.size.over]
                                that.updateStorageUserInfo(that.total[1])
                            }
                            else {
                                //页面删除选中项
                                that.updateOverAction(res)
                            }
                            that.calculation()
                        }else
                            that.$toast.fail(res.msg)
                    })
                }).catch(() => {})
            },
            /**
             * 删除或订阅后的更新操作
             * */
            updateOverAction(res){
                let that = this
                let del_item_list = []
                that.list.forEach(function (c, i) {
                    if (that.chk_select_list.indexOf(c.cid) > -1)
                        del_item_list.push(i)
                })
                del_item_list.reverse().forEach(function (c) {
                    that.list.splice(c, 1)
                })
                that.chk_select_list = []
                that.ischkAll = false
                that.overischkAll = false
                that.total = [res.data.size.all, res.data.size.invalid, res.data.size.over]
                that.updateStorageUserInfo(that.total[1], res.data.user)
                that.calculation()
            },
            /**
             * 更新用户购物车数量
             * @param size
             */
            updateStorageUserInfo(size, user){
                let that = this, userInfo = JSON.parse(localStorage.getItem('user'))
                userInfo.cart = size
                if(user){
                    userInfo.amt = user.amt
                    userInfo.integral = user.integral
                    that.user.amt = user.amt
                    that.user.integral_def = user.integral
                }
                that.setTotalText()
                this.$store.commit('SET_USER', userInfo)
            },
            /**
             * 更新订阅剩余时间
             */
            updateListDyStatus(){
                let that = this
                that.list.forEach(function (c) {
                    if(c.match.dystatus === 2) {
                        c.match.sytime = c.match.sytime-1
                        if(c.match.sytime<=0) {
                            c.match.dystatus = 0 //等待公开
                            // clearInterval(that.timer)
                        }
                        c.match.sytime_text = that.$formatSeconds(c.match.sytime)
                        // console.log(c.sytime_text)
                    }
                })
            },
            goBack(){
                let that = this, path = that.formPath
                if(path === undefined || path === '') {
                    that.$router.back()
                }else {
                    that.$router.replace({path: path})
                }
            },
            toTreaty(){
                this.$store.commit('SHOW_TREATY')
            },
            toMianze(){
                this.$store.commit('SHOW_MIANZE')
            },

        },
        beforeDestroy() {
            clearInterval(this.timer)
            this.timer = null
            // console.log('destroy')
            this.init = true
        },
        mounted() {
            let that = this
            that.timer = setInterval(()=>{
                that.updateListDyStatus() //定时更新订阅剩余时间
            }, 1000)
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path === '/' ?'/ball':''
            })
        }
    }
</script>

<style scoped>
</style>
